import * as marietta from '../../..';
import { Dialog } from '../../../core/view';

/**
 * MyHomeCloudお問い合わせダイアログ
 */
class ContactUsDialog extends Dialog {
  /**
     * コンストラクタ
     */
  constructor(draggable: boolean) {
    super(draggable);

    // ダイアログのコンテンツ生成
    const id = 'contactUsDialog';
    let title = '';
    // タイトル
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'jp': title = 'お問合せ'; break;
      default: title = 'Contact Us'; break;
    }

    let contents = '';
    contents += '<div class="p-contactBox contactUsDialog_contentBox">';
    contents += '<form>';
    contents += '<div class="formTableWrap">';
    contents += '<p><label for="contactName"><span class="jp">お名前</span><span class="en">Name</span></label><span><input type="text" id="contactName" placeholder="';
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'jp': contents += '田中 太郎"></span></p>'; break;
      default: contents += 'Taro Tanaka"></span></p>'; break;
    }
    contents += '<p><label for="contactMailaddress"><span class="jp">メールアドレス</span><span class="en">e-mail</span></label><span><input type="email" id="contactMailaddress" placeholder="xxxx@xxxx.com"></span></p>';
    contents += '<p>';
    contents += '<label for=""><span class="jp">お問い合わせの種類</span><span class="en">Subject</span><span class="require"> ※</span></label>';
    contents += '<span>';
    contents += '<select name="" id="contactType">';

    switch (marietta.webcad.WebCADGlobal.language) {
      case 'jp':
        contents += '<option value="" selected="selected">選択してください</option>';
        contents += '<option value="demand">ご要望</option>';
        contents += '<option value="question">ご質問</option>';
        contents += '<option value="bug">不具合報告</option>';
        break;
      default:
        contents += '<option value="" selected="selected">Please Select</option>';
        contents += '<option value="demand">Send a Request</option>';
        contents += '<option value="question">Ask a Question</option>';
        contents += '<option value="bug">Report a Bug</option>';
        break;
    }

    contents += '</select>';
    contents += '<span class="validateMsg"></span>';
    contents += '</span>';
    contents += '</p>';
    contents += '<p>';
    contents += '<label for=""><span class="jp">お問い合わせ内容</span><span class="en">Message</span><span class="require"> ※</span></label>';
    contents += '<span>';
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'jp':
        contents += '<textarea name="" id="contactMsg" cols="30" placeholder="ご用件を入力してください。" value=""></textarea>';
        break;
      default:
        contents += '<textarea name="" id="contactMsg" cols="30" placeholder="Please input your message here." value=""></textarea>';
        break;
    }

    contents += '<span class="validateMsg"></span>';
    contents += '</span>';
    contents += '</p>';
    contents += '</div>';
    contents += '<div class="dialogError">aaaaaaaaa</div>';
    contents += '<div class="formSubmit">';
    contents += '<button id="btnSubmitContact"><span class="jp">送信</span><span class="en">Send</span></button';
    contents += '</div>';
    contents += '</form>';
    contents += '</div>';
    contents += '</div>';

    // footer = '<button id="btnOK"><span class="jp">ＯＫ</span><span class="en">OK</span></button>';
    const footer = '';
    this.createDialog(id, title, contents, footer);

    // イベント
    const self = this;
    marietta.webcad.WebCADGlobal.webcad2Dmanager.checkLogin(self.setUserInfo);
    document.getElementById('btnSubmitContact').addEventListener('click', self.onSubmitClicked);

    if (marietta.webcad.WebCADGlobal.userAgentManager.isIE) {
      document.getElementById('helpPerformanceNotShowDiv').style.display = 'none';
    }

    // document.getElementById('btnOK').addEventListener('click', this.btnEventHandler);
  }

    /**
     * OKボタンがクリックされた
     * パフォーマンスチェッカーの可視性の処理
     * @return void
     * @param e => mouse event
    */
    btnEventHandler = (e: any) => {
      e.preventDefault();
      // パネルを閉じる
      marietta.webcad.WebCADGlobal.removeDialog();
    }

    /**
     * 名前とメールアドレスをセット
     */
    // eslint-disable-next-line class-methods-use-this
    setUserInfo(info) {
      (<HTMLInputElement>document.getElementById('contactName')).value = (info.body.nickname);
      (<HTMLInputElement>document.getElementById('contactMailaddress')).value = (info.body.email);
    }

    contactType:string;

    contactContent:string;

    /**
     * 送信ボタンが押された
     */
    onSubmitClicked = (e) => {
      e.preventDefault();

      // エラーメッセージを初期化
      (<HTMLElement> this.viewObj.querySelector('.dialogError')).style.display = 'none';

      // 入力項目の確認
      this.checkRequiredForms();
    }

    /**
     * 入力項目の確認
     */
    checkRequiredForms() {
      // 種類（選択の有無）
      let msg = '';
      let errorFlag = false;
      this.contactType = (<HTMLInputElement>document.getElementById('contactType')).value;
      if (!this.contactType) {
        switch (marietta.webcad.WebCADGlobal.language) {
          case 'jp': msg = 'お問い合わせの種類を選択してください。'; break;
          default: msg = 'Please select the subject.'; break;
        }
        const erroeMsg = document.getElementById('contactType').nextElementSibling;
        erroeMsg.textContent = msg;
        erroeMsg.classList.add('is-error');
        errorFlag = true;
      } else {
        const erroeMsg = document.getElementById('contactType').nextElementSibling;
        erroeMsg.classList.remove('is-error');
      }

      // 内容（入力の有無）
      this.contactContent = (<HTMLInputElement>document.getElementById('contactMsg')).value;
      console.log(this.contactContent.length);
      if (this.contactContent === '') {
        switch (marietta.webcad.WebCADGlobal.language) {
          case 'jp': msg = 'お問い合わせ内容を記入してください。'; break;
          default: msg = 'Please input your message'; break;
        }
        const erroeMsg = document.getElementById('contactMsg').nextElementSibling;
        erroeMsg.textContent = msg;
        erroeMsg.classList.add('is-error');
        errorFlag = true;
      } else if (this.contactContent.length > 5000) {
        switch (marietta.webcad.WebCADGlobal.language) {
          case 'jp': msg = '5,000文字以内で記入してください。'; break;
          default: msg = 'Message must be within 5000 characters.'; break;
        }
        const erroeMsg = document.getElementById('contactMsg').nextElementSibling;
        erroeMsg.textContent = msg;
        erroeMsg.classList.add('is-error');
        errorFlag = true;
      } else {
        const erroeMsg = document.getElementById('contactMsg').nextElementSibling;
        erroeMsg.classList.remove('is-error');
      }

      // ダイアログのサイズ調整
      this.centerDialog();

      if (errorFlag) return;
      this.submitContactData();
    }

    /**
     * お問い合わせを送信
     */
    private submitContactData() {
      marietta.webcad.WebCADGlobal.showBusy();
      const self = this;
      const userName = (<HTMLInputElement>document.getElementById('contactName')).value;
      const userEmail = (<HTMLInputElement>document.getElementById('contactMailaddress')).value;
      const closeFunc = self.close;
      const url = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.webcad_url}tools/api/feedback`;

      // 必須項目のデータを作成
      let data = `domain=${marietta.webcad.WebCADGlobal.webcad2Dmanager.domain}`;
      data += `&type=${this.contactType}`;
      data += `&content=${this.contactContent}`;

      // XMLを文字列に変換
      const xml = marietta.webcad.WebCADGlobal.webcad2Dmanager.getSaveData();
      const xmlSerializer = new XMLSerializer();
      let xmlString = xmlSerializer.serializeToString(xml);

      xmlString = xmlString.replace(/xmlns="http:\/\/www.w3.org\/1999\/xhtml"/g, '');
      data += `&data=${xmlString}`;

      // 任意項目
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.planID) data += `&property_=${marietta.webcad.WebCADGlobal.webcad2Dmanager.planID}`;
      if (userName) data += `&user_name=${userName}`;
      if (userEmail) data += `&user_email=${userEmail}`;
      fetch(url, {
        method: 'POST',
        body: data,
      }).then((response) => {
        if (response.status >= 200 && response.status <= 299) {
          return response.text();
        }
        throw Error(response.statusText);
      }).then((info) => {
        const xmlResponse = new window.DOMParser().parseFromString(info, 'text/xml');
        const error = xmlResponse.getElementsByTagName('error');
        if (error.length === 0) {
          closeFunc();
          // HideBusy
          marietta.webcad.WebCADGlobal.hideBusy();

          // 保存しましたダイアログを表示する
          marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('NOTICE_REQUEST_SENT'));
        } else {
          // エラーメッセージを表示
          console.log(error[0].children[1].innerHTML);
          (<HTMLElement> this.viewObj.querySelector('.dialogError')).textContent = error[0].children[1].innerHTML;
          (<HTMLElement> this.viewObj.querySelector('.dialogError')).style.display = 'block';

          // HideBusy
          marietta.webcad.WebCADGlobal.hideBusy();
        }
        // ダイアログのサイズ調整;
        self.centerDialog();
      }).catch(() => {
        marietta.webcad.WebCADGlobal.hideBusy();
        // エラーメッセージの初期化
        switch (marietta.webcad.WebCADGlobal.language) {
          case 'en': (<HTMLElement> this.viewObj.querySelector('.dialogError')).textContent = 'Error: Cannot find connection. Please check your network.'; break;
          default: (<HTMLElement> this.viewObj.querySelector('.dialogError')).textContent = '通信エラー:ネットワーク環境をご確認ください。'; break;
        }
        (<HTMLElement> this.viewObj.querySelector('.dialogError')).style.display = 'block';

        // ダイアログのサイズ調整
        self.centerDialog();
      });
    }
}

export default ContactUsDialog;
